import {useDispatch, useSelector} from "react-redux";
import {editTaxNumber, getTaxNumber} from "store/actions";
import Loader from "components/shared/loader";
import {useNavigate} from "react-router-dom";
import SaveChangesButton from "components/Form/save-changes-button";
import Form from "components/Form";
import Input from "components/Form/input";
import {useEffect} from "react";
import FormWrapper from "components/Form/form-wrapper";

const ViewEditProfile = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {
        settings: {taxNumber, loading},
    } = useSelector((state) => state);

    useEffect(() => {
        dispatch(getTaxNumber());
    }, [dispatch]);

    const onSubmit = (data) => {
        dispatch(editTaxNumber({data, navigate}));
    };
    if (loading) return <Loader />;

    return (
        <FormWrapper title={"taxNumber"}>
            <Form onSubmit={onSubmit} defaultValues={taxNumber?.[0]}>
                <Input />
                <SaveChangesButton />
            </Form>
        </FormWrapper>
    );
};

export default ViewEditProfile;
